var _a;
import { CategoryClass as ServerCategoryClass } from '@api-gen/api';
import { createDataRecordConverter } from '@core/utils/helpers';
import { CategoryClass as ClientCategoryClass } from '@features/guidbooks/types';
export var categoryClassMap = createDataRecordConverter((_a = {},
    _a[ClientCategoryClass.General] = ServerCategoryClass.General,
    _a[ClientCategoryClass.A] = ServerCategoryClass.A,
    _a[ClientCategoryClass.B] = ServerCategoryClass.B,
    _a[ClientCategoryClass.C] = ServerCategoryClass.C,
    _a));
export var convertToServerCategoryClassData = function (type) {
    return categoryClassMap.toServer[type];
};
export var convertToClientCategoryClassData = function (type) {
    return categoryClassMap.toClient[type];
};
